(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   window load
 *   drupal behavior
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {


		/* Open first item */
		$('.view-customer-zone-my-orders .views-row:first-child .customer-order-item').addClass('is-active');


		/* Orders open/close */
		const $orderTeaser = $('.order-item__teaser');

		$orderTeaser.on('click', function(){

			if (!$(this).parent().hasClass('is-active')) {

				// Scroll to focus point (only when you open the order)
				if($('body').hasClass('toolbar-horizontal')) {
					$('html,body').animate({scrollTop: $(this).offset().top - 80},'slow');
				} else {
					$('html,body').animate({scrollTop: $(this).offset().top},'slow'); 
				}

			}

			$(this).parent().toggleClass('is-active');

		});


	});

})(jQuery);
